import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../../images/case-studies/point2-design/result_banner.png";

function Resultpoint() {
  return (
    <section
      className="result_point text_white"
      style={{ backgroundImage: `url(${BgImg})`, backgroundColor: "#000" }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={10}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>
              Results and <span style={{ color: "#E8E751" }}>Impact</span>
            </h2>
            <p>
              The launch of Point 2 Design has had a profound impact on the
              order management process by enabling celebrities to add digital
              signatures via Apple Pencil. The app has automated the tradition
              of adding personalized signatures by saving both time and effort
              to make it possible. Moreover, the efficiency and accuracy of
              order processing have also increased.
            </p>
            <p>
              TekRevol's expertise in order desk integration resulted in
              seamless connectivity between the app and the order management
              system, ensuring real-time updates and enhanced order tracking
              capabilities.
            </p>
            <div className="result_img mt-5">
              <StaticImage
                src="../../../images/case-studies/point2-design/result_img.png"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={1576}
                height={365}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Resultpoint;
